export * from './NativeLangOptions';
export * from './GenderOptions';
export * from './ChildCollectionOptions';
export * from './ExamType';
export * from './AwardingBodyIdentifiers';
export * from './PaymentType';
export * from './CountryIdentifiers';
export * from './PrsServiceType';
export * from './PrsStatus';

export const B2C_SUB_SYSTEM_ID = 3;
export const B2C_SUB_SYSTEM_SHORT_CODE = 'B2C';
export const B2B_SUB_SYSTEM_SHORT_CODE = 'B2B';
export const INPUT_DATE_FORMAT = 'yyyy-MM-dd';
export const DISPLAY_DATE_FORMAT = 'dd/MM/yyyy';
export const DISPLAY_DATE_AND_TIME_FORMAT = 'dd/MM/yyyy HH:mm';
export const NATIONALITY_ID_SHORT_CODE = 'NATL_ID';
